











































import UserRequired from "../UserRequired";
import {Component, Inject, Prop, Watch} from "vue-property-decorator";
import Api from "@/components/location/Api";
import {TerminalLocation, TerminalLocationRegcode} from "@/modules/models";

@Component
export default class LocationPoster extends UserRequired {
    @Prop()
    locationId!: number;

    @Inject()
    api!: Api;

    location: TerminalLocation | null = null;
    regcodes: TerminalLocationRegcode[] = [];

    @Watch("locationId", {immediate: true})
    async onLocationIdChange(n: number) {
        const locationP = this.api.fetchTerminalLocation(n);
        const regcodesP = this.api.fetchTerminalLocationRegcodes(n);
        this.location = await locationP;
        this.regcodes = await regcodesP;
    }

    get mostRecentRegcode() {
        // Returned regcode list is sorted ascending by id, so most recent is always the last in the list
        if(this.regcodes.length > 0) {
            return this.regcodes[this.regcodes.length - 1];
        } else {
            return null;
        }
    }

    get showRegcode() {
        return this.mostRecentRegcode != null && this.mostRecentRegcode.toTs === null;
    }
}
